import util from "./utils";
import {BeiJin, Xzs, Api, xzApi} from "./cli";
const axios = util.ajax;


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['clientid'] = "041fd3cdf170f4104baf5a15621344cc";



/**
 * @module 登录
 * @method 登录接口
 */
export const loginRequest = data => {
    return axios.request({
        url: `${Api}/auth/login`,
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}

/**
 * @module 登录
 * @method 登录接口
 */
export const logoutRequest = data => {
    return axios.request({
        url: `${Api}/auth/logout`,
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}



export const getUserInfo = () => {
    return axios.request({
        method: 'get',
        url: `${BeiJin}/operator/getUserId`
    })
}

/**
 * @author wenc
 * @param {*} userName
 */
export const sendSmsCode = (params) => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/resource/sms/code`,
        method: "get",
        params
    })
}

/**
 * @author
 * 获取代销者信息接口，需要接口请求头的token，无需传实际参数
 */
export const agentInfoList = (params) => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/xzs/agentInfo/list`,
        method: "get",
        params
    })
}


/**
 * @author
 * 获取网点信息接口，需要接口请求头的token，需传实际参数网点编号的参数
 */
export const branchInfoList = (params) => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/xzs/branchInfo/list`,
        method: "get",
        params
    })
}
export const branchInfoList2 = (params) => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/xzs/branchInfo/list2`,
        method: "get",
        params
    })
}
//查询网点信息
export const branchInfoList3 = (params) => {
    return axios.request({
        url: `${Api}/xzs/branchInfo/list3`,
        method: "get",
        params
    })
}

/**
 * @author
 * 获取销售员的网点信息接口，需要接口请求头的token，
 */
export const salespersonInfoList = (params) => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/xzs/salespersonInfo/list`,
        method: "get",
        params
    })
}

/**
 * @author
 * 获取销售员信息接口，需要接口请求头的token，userId参数传递
 */
export const salesUserInfo = (params) => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/xzs/salespersonInfo`,
        method: "get",
        params
    })
}




/**
 * @author
 * 修改网点接口，需要接口请求头的token，参数传递整个网点信息接口的参数
 */
export const updateBranchInfo = data => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/xzs/branchInfo`,
        method: 'put',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}


/**
 * @author
 * 审核销售员接口，需要接口请求头的token，参数传递整个网点信息接口的参数
 */
export const updateSalespersonInfo = data => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/xzs/salespersonInfo`,
        method: 'put',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}


/**
 * @author
 * 修改代销者信息接口，需要接口请求头的token，参数传递
 */
export const updateAgentInfo = data => {
    return axios.request({
        // url: `${Gx}/resource/sms/code`,
        url: `${Api}/xzs/agentInfo`,
        method: 'put',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}

/**
 * @author
 * 修改代销者手机号接口，需要接口请求头的token，参数传递
 */
export const changePhoneNumber = data => {
    return axios.request({
        url: `${Api}/xzs/agentInfo/changePhoneNumber`,
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}

/*
*
* 专管员-----------维修员
*
*
* */
//  当前列表
export const processApplyList = (params) => {
    return axios.request({
        url: `${Api}/process/applyList`,
        method: "get",
        params
    })
}
export const processNewdetails = (params) => {
    return axios.request({
        url: `${Api}/process/newdetails`,
        method: "get",
        params
    })
}
// 流程里面已经做完的流程数据
export const processTaskHistorical = (params) => {
    return axios.request({
        url: `${Api}/process/task/historical`,
        method: "get",
        params
    })
}
// 返回true 就是有在运行的流程，false就是没有
export const processIsinservice = (params) => {
    return axios.request({
        url: `${Api}/process/isinservice`,
        method: "get",
        params
    })
}
// 当前列表
export const processUserUnclaimed = (params) => {
    return axios.request({
        url: `${Api}/process/unclaimed`,
        method: "get",
        params
    })
}
//     历史列表
export const processUserRelevanceCompleteList = (params) => {
    return axios.request({
        url: `${Api}/process/userRelevanceCompleteList`,
        method: "get",
        params
    })
}
// 第一步先查出来流程的类型
// 流程类型
export const processFlowlist = (params) => {
    return axios.request({
        url: `${Api}/process/flowlist`,
        method: "get",
        params
    })
}
// 第二步去找对象的流程去新建
//新建流程
export const processFlowinit = data => {
    return axios.request({
        url: `${Api}/process/flowinit`,
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}
// 第三步如果流程有提交
// 提交流程
export const processGeneralsubmit = data => {
    return axios.request({
        url: `${Api}/process/generalsubmit?taskId=${data.taskId}&processDefinitionName=${data.processDefinitionName}`,//
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}
// 第三步如果流程未提交关闭
//删除流程(新建流程 但未 提交流程，取消或者关闭时执行删除操作)
export const processRemove = data => {
    return axios.request({
        url: `${Api}/process/remove`,
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}


//调查问卷-问题列表
export const questionnaireList = (params) => {
    return axios.request({
        url: `${Api}/marketing/questionnaire/detailAll`,
        method: "get",
        params
    })
}
//调查问卷-答题提交
export const userQuestionnaireResult = data => {
    return axios.request({
        url: `${Api}/marketing/userQuestionnaireResult/addAll`,
        method: 'post',
        contentType: "application/json; charset=utf-8",
        data: data
    })
}

export const inspectionMobilePageList = (params) => {
    return axios.request({
        url: `${Api}/inspection/info/mobilePageList`,
        method: "get",
        params
    })
}
export const inspectionReceiptor = (params) => {
    return axios.request({
        url: `${Api}/inspection/details/receiptor/${params.id}/${params.inspectorstype}`,
        method: "get",
        params
    })
}
export const inspectionMobileInfoRatio = (params) => {
    return axios.request({
        url: `${Api}/inspection/info/mobileInfoRatio`,
        method: "get",
        params
    })
}
export const inspectionFlowtypenum = (params) => {
    return axios.request({
        url: `${Api}/process/flowtypenum`,
        method: "get",
        params
    })
}
export const processAllmytask = (params) => {
    return axios.request({
        url: `${Api}/process/allmytask`,
        method: "get",
        params
    })
}
export const xzsStaffInfoParty = (params) => {
    return axios.request({
        url: `${Api}/xzs/staffInfo/party`,
        method: "get",
        params
    })
}
export const salesManageInfo = (params) => {
    return axios.request({
        url: `${Api}/salesmanage/salesinfo/statistics`,
        method: "get",
        params
    })
}
// /xzs/branchInfo/judgeDistance
export const branchInfoJudgeDistance = (params) => {
    return axios.request({
        url: `${Api}/xzs/branchInfo/judgeDistance`,
        method: "get",
        params
    });
}


// 耗材管理
// 查询仓库库存信息列表
//
export const consumablesWarehouseStockList = (params) => {
    return axios.request({
        url: `${Api}/consumables/warehouseStock/list`,
        method: "get",
        params
    });
}
//新增网点订单信息
export const consumablesBranchOrderInfo = data => {
    return axios.request({
        url: `${Api}/consumables/branchOrderInfo`,
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    });
}
// 查询网点剩余打印纸数量
export const consumablesBranchStock = (params) => {
    return axios.request({
        url: `${Api}/consumables/branchStock/${params.stockId}`,
        method: "get",
        params
    });
}

//查询网点订单信息列表
export const consumablesBranchOrderList = (params) => {
    return axios.request({
        url: `${Api}/consumables/branchOrderInfo/list`,
        method: "get",
        params
    });
}
// 专管员耗材列表页
export const consumablesOrderWareHousekeeperList = (params) => {
    return axios.request({
        url: `${Api}/consumables/branchOrderInfo/warehousekeeperlist`,
        method: "get",
        params
    });
}
// 专管员首页，显示耗材库存数量和本月出库量
export const consumablesWareHouseStockStatistics = (params) => {
    return axios.request({
        url: `${Api}/consumables/warehouseStock/outboundStatistics`,
        method: "get",
        params
    });
}
//分中心首页，统计数量
export const consumablesWareHouseStatistics = (params) => {
    return axios.request({
        url: `${Api}/consumables/warehouseStock/statistics`,
        method: "get",
        params
    });
}
//新增仓库申领订单信息
export const consumablesWareHouseOrderInfo = data => {
    return axios.request({
        url: `${Api}/consumables/warehouseOrderInfo`,//
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}

export const consumablesOrderSortRelation = data => {
    return axios.request({
        url: `${Api}/consumables/orderSortRelation`,//barcode、orderId、whId
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}


export const warehouseOrderInfoList = (params) => {
    return axios.request({
        url: `${Api}/consumables/warehouseOrderInfo/list`,
        method: "get",
        params
    });
}
// 仓库信息列表
export const warehouseInfoList = (params) => {
    return axios.request({
        url: `${Api}/xzs/warehouseInfo/list`,
        method: "get",
        params
    });
}
// 当前任务中的未完成的任务
export const processIncompletePersonalList = (params) => {
    return axios.request({
        url: `${Api}/process/incompletePersonalList`,
        method: "get",
        params
    });
}
// /
export const processTasksNumber = (params) => {
    return axios.request({
        url: `${Api}/process/tasksNumber`,
        method: "get",
        params
    });
}
//判断网点编号和人员信息是否注册
export const processIsBind = (params) => {
    return axios.request({
        url: `${Api}/process/mobileisBind`,
        method: "get",
        params
    });
}
//  比较坐标距离是否过远
export const processIsCord = (params) => {
    return axios.request({
        url: `${Api}/process/distance`,//coord=&coord1=
        method: "get",
        params
    });
}
//订单详情接口
export const consumablesBranchOrderInfoId = (params) => {
    return axios.request({
        url: `${Api}/consumables/branchOrderInfo/${params.orderId}`,//coord=&coord1=
        method: "get",
        params
    });
}
//根据订单，查询出库的箱号、操作人员等信息
export const consumablesOrderSortRelationList = (params) => {
    return axios.request({
        url: `${Api}/consumables/orderSortRelation/list`,//coord=&coord1=
        method: "get",
        params
    });
}
//流程结束后，提交上传图片接口
export const processUploadFiles = data => {
    return axios.request({
        url: `${Api}/process/uploadFiles`,
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}
// 西藏省市区
export const dynamicDataLocation = (params) => {
    return axios.request({
        url: `${Api}/dynamicData/location`,
        method: "get",
        params
    });
}
// 查询流程中的专管员列表
export const dynamicDataListSpecialManager = (params)=>{
    return axios.request({
        url:`${Api}/dynamicData/listSpecialManager`,
        method: "get",
        params
    })
}
//下载接口，返回二进制文件
export const changeManageExport = (params) => {
    return axios.request({
        url: `${Api}/changemanage/correction/export`,
        method: 'post',
        headers: {
            contentType: "application/x-www-form-urlencoded",
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        responseType: 'blob',
        params
    })
}

// 10.	通知设备播放音频报警
export const medium_audioFileNotifyLib = data => {
    return axios.request({
        url: `${xzApi}/api/audioFile/notify?id=${data.id}&notify=${data.notify}`,//
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}
export const noticeContent = (params) => {
    return axios.request({
        url: `${Api}/notice/noticeContent/${params.id}`,
        method: "get",
        params
    });
}
//   大屏配置  2.删除素材
export const wx_hdmi_material_delete = (params) => {
    return axios.request({
        url: `${xzApi}/api/wx/hdmi/material/delete/${params.id}`,
        method: "delete",
        params
    });
}
//   大屏配置   8.删除盒子节目
export const wx_hdmi_programPlan_del = (params) => {
    return axios.request({
        url: `${xzApi}/api/wx/hdmi/programPlan/${params.id}`,
        method: "delete",
        params
    });
}
//   大屏配置  12.节目单素材删除
export const wx_hdmi_plan_material_del = (params) => {
    return axios.request({
        url: `${xzApi}/api/wx/hdmi/plan/material/delete/${params.id}`,
        method: "delete",
        params
    });
}

// 阳光征召
//
export const ygRecruitInfoList = (params)=>{
    return axios.request({
        url:`${Api}/ygzz/recruitInfo/list`,
        method: "get",
        params
    })
}
export const ygRecruitInfoId = (params) => {
    return axios.request({
        url: `${Api}/ygzz/recruitInfo/${params.recruitId}`,
        method: "get",
        params
    });
}
export const ygChangeInformationStatus = (params) => {
    return axios.request({
        url: `${Api}/ygzz/recruitInfo/changeInformationStatus`,
        method: "get",
        params
    });
}
export const ygChangeScenesStatus = (params) => {
    return axios.request({
        url: `${Api}/ygzz/recruitInfo/changeScenesStatus`,
        method: "get",
        params
    });
}
export const recruitInfoPut = data => {
    return axios.request({
        url: `${Api}/ygzz/recruitInfo`,
        method: 'put',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}
// 考勤打卡
// 新增考勤打卡记录
export const attendance_attendanceRecords = data => {
    return axios.request({
        url: `${Api}/attendance/attendanceRecords`,//
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}
// 获取员工考勤打卡时间
export const attendance_attendanceRecords_attendanceTime = (params) => {
    return axios.request({
        url: `${Api}/attendance/attendanceRecords/attendanceTime/${params.userId}`,
        method: "get",
        params
    });
}
//新增请假信息
export const attendance_attendanceLeaveApplications = data => {
    return axios.request({
        url: `${Api}/attendance/attendanceLeaveApplications`,//
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}
// 是否可以请假接口
export const attendance_attendanceLeaveApplications_judgeLeave = (params) => {
    return axios.request({
        url: `${Api}/attendance/attendanceLeaveApplications/judgeLeave/${params.userId}`,
        method: "get",
        params
    });
}
// 藏历数据
//
export const attendance_calendarInfo_list = (params) => {
    return axios.request({
        url: `${Api}/attendance/calendarInfo/list`,
        method: "get",
        params
    });
}
//绩效管理员设置参数查询
export const performanceConfig_detailList = data => {
    return axios.request({
        url: `${Api}/xzs/performanceConfig/detailList`,//
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}
//绩效管理员设置参数修改提交
export const performanceConfig_updatePerformanceDetail = data => {
    return axios.request({
        url: `${Api}/xzs/performanceConfig/updatePerformanceDetail`,//
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}

//

//绩效管理员，查询当前区域的专管员
export const performanceStaffInfo_list = (params) => {
    return axios.request({
        url: `${Api}/xzs/performanceStaffInfo/list2`,
        method: "get",
        params
    });
}

export const performanceConfig_updateOther = data => {
    return axios.request({
        url: `${Api}/xzs/performanceStaffInfo/updateOther`,//
        method: 'post',
        headers: {
            isEncrypt:true,
            clientid:"041fd3cdf170f4104baf5a15621344cc"
        },
        contentType: "application/json; charset=utf-8",
        data: data
    })
}


// 消息通知，发送文件到邮箱
export const noticeContent_sendMessageWithAttachment = (params) => {
    return axios.request({
        url: `${Api}/notice/noticeContent/sendMessageWithAttachment`,
        method: "get",
        params
    });
}

// http://192.168.8.123:8080/inspection/details/explain/businessType get请求businessType就是参数，根据不同id变更这个
export const inspection_explain_details = (params) => {
    return axios.request({
        url: `${Api}/inspection/details/explain/${params.id}`,
        method: "get",
        params
    });
}
// 任务列表（带搜索和筛选条件）
export const process_flowClassifiedQuery = (params) => {
    return axios.request({
        url: `${Api}/process/flowClassifiedQuery`,
        method: "get",
        params
    });
}
//网点销量信息接口
export const salesmanage_salesinfo_siteSales = (params) => {
    return axios.request({
        url: `${Api}/salesmanage/salesinfo/siteSales`,
        method: "get",
        params
    });
}
// 生成网点编号接口
export const device_manager_installInfo = (params) => {
    return axios.request({
        url: `${Api}/devicemanager/installInfo/newSiteId`,
        method: "get",
        params
    });
}
// 文件发送邮箱
export const process_downloadTheFileEmail = (params) => {
    return axios.request({
        url: `${Api}/process/downloadTheFileEmail`,
        method: "get",
        params
    });
}


// /devicemanager/installInfo/newSiteId?county
// 调接口模版
// salesManageInfo({
//     siteId:
// }).then((res)=>{
//     if(res){
//         if(res.data){
//             if(res.data.code===200){
//
//             }else{
//                 this.$toast.fail(res.data.msg);
//             }
//         }
//     }
// });